<script>
import {
    eventGroupState, setEventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    setMetadataState
} from '@app/store/metadataStore.svelte.js';
import {
    projectState, resetProjectState
} from '@app/store/projectStore.svelte.js';
import {
    setSpeakerState
} from '@app/store/speakerStore.svelte.js';
import {
    setIssues
} from '@app/store/issueStore.svelte.js';
import {
    resetMarkerStateWithData
} from '@app/store/markerStore.svelte.js';
import {
    updateFontState
} from '@app/store/fontStore.svelte.js';
import {
    historyState, undo, redo
} from '@app/store/historyStore.svelte.js';
import * as m from '@app/paraglide/messages.js';

import _EventGroup from '@cclib/classes/eventGroup.js';
import _Event from '@cclib/classes/event.js';

function undoHistory() {
    undo();
    loadSnapshots();    
}

function redoHistory() {
    redo();
    loadSnapshots();    
}

function loadSnapshots() {
    let cachedEvents = eventGroupState[projectState.selected]?.selected;
    eventGroupState[projectState.selected].selected = [];
    historyState.actions[historyState.position-1].snapshots.forEach(snapshot => {
        switch (snapshot.store) {
            case "eventGroupState":
                setEventGroupState(JSON.parse(snapshot.value))
                break;
            case "metadataState":
                // Clear the array first
                setMetadataState(JSON.parse(snapshot.value));
                break;
            case "projectState":
                resetProjectState(JSON.parse(snapshot.value));
                break;
            case "speakerState":
                setSpeakerState(JSON.parse(snapshot.value));
                break;
            case "issueState":
                setIssues(JSON.parse(snapshot.value));
                break;
            case "markerState":
                resetMarkerStateWithData(JSON.parse(snapshot.value));
                break;
            case "fontState":
                updateFontState(snapshot.value);
                break;
            default:
                console.log("----UNKNOWN STORE NAME----");
        }
    });    

    if (historyState.actions[historyState.position-1].eventGroup !== false && historyState.actions[historyState.position-1].eventGroup !== undefined){
        projectState.selected = historyState.actions[historyState.position-1].eventGroup;
        eventGroupState[projectState.selected].selected = [];
    } 
    
    if (eventGroupState[projectState.selected] && eventGroupState[projectState.selected].events[cachedEvents[0]]){
        setTimeout(() =>{
            eventGroupState[projectState.selected].selected = [cachedEvents[0]];
        }, 250)        
    }
}
</script>

<!-- Undo -->
<a class="dropdown-item {historyState.position <= 1 ? 'disabled' : ''}" 
   href="#!/" 
   onclick={() => undoHistory()}
   role="menuitem"
   id="edit-undo"
   aria-disabled={historyState.position <= 1}>
    <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i> {m.common_undo()}
    {#if historyState.position > 1}
        {historyState.actions[historyState.position-1].name}
    {/if}
</a>
<!-- Redo -->
<a class="dropdown-item {historyState.position === historyState.actions.length ? 'disabled' : ''}" 
   href="#!/" 
   onclick={() => redoHistory()}
   role="menuitem"
   id="edit-redo"
   aria-disabled={historyState.position === historyState.actions.length}>
    <i class="bi bi-arrow-clockwise" aria-hidden="true"></i> {m.common_redo()}
    {#if historyState.actions.length > historyState.position}
        {historyState.actions[historyState.position].name}
    {/if}
</a>
